import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ListPage from './list/list';

const PaymentModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path="/" element={<ListPage />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default PaymentModule;
